import dayjs from 'dayjs';
import { useState } from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

export default function TimeInputField({sendTimeFromChild, timeInput, name}) {
	const [value, setValue] = useState(null);
	const handleTime = (value) => {
		setValue(value);
		sendTimeFromChild({"id" : name, "time" : value.$d});
	}
    
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<DemoContainer components={['TimePicker']}>
				<TimePicker name={name ? name : 'time'} value={value || dayjs(timeInput, 'hh:mm A')} onChange={(newValue) => handleTime(newValue)} 
				sx={{"& .MuiOutlinedInput-root": { "&:hover > fieldset": { border: '0px solid #F1F1F1'}} }} 
				className='bg-background-normal focus:outline-none p-4 rounded-lg border border-none'/>
			</DemoContainer>
		</LocalizationProvider>
	);
}